import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const SingleTransitPolicyFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1.What is the difference between a single transit policy and an annual transit policy?",
      answer: (
        <>
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}> Single Transit Policy:</span>
       • Coverage: Covers goods for one specific shipment.
       • Duration: Protects items during a single trip from origin to destination.
       • Ideal For: Businesses with occasional or irregular shipping needs.
       • Flexibility: Tailored for each shipment's unique risks and value.

      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Annual Transit Policy:</span>
      • Coverage: Provides continuous protection throughout the policy year.
      • Duration: Covers multiple shipments over a 12-month period.
      • Ideal For: Businesses with regular or frequent shipping activities.
      • Cost Efficiency: Eliminates the need for separate insurance for each shipment.

        </>
      )
    },
    {
      question: "Q2.How long does coverage last under a single transit policy?",
      answer: (
        <>
         A single transit policy provides coverage for goods during <span style={{ color: "#F37435", fontWeight: "700" }} >one specific trip</span>. It begins when the goods depart from their starting point and continues throughout their journey until they reach their final destination. This type of insurance ensures that goods are protected for the duration of that single transport journey.
       </>
      )
    },
    {
      question: "Q3.Is a single transit policy necessary if I already have a business insurance policy?",
      answer:(
        <>
        Even if you have business insurance, a single transit policy might still be necessary. Here's why:
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Specific Coverage:</span> Business insurance may not cover goods in transit. A single transit policy ensures your items are protected while being transported.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Focused Protection: </span>It addresses unique risks like theft or damage during transit, which might not be included in your general business policy.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Peace of Mind: </span>Knowing your goods are insured for the trip reduces financial risks associated with shipping.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}> Customized Coverage: </span>These policies can be tailored to each shipment, covering the specific goods, transport method, and route.
      </>
      )
      },

      {
        question: "Q4.What is per sending limit?",
        answer:(
          <>
           In a single transit policy, the "per sending limit" is the <span style={{ color: "#F37435", fontWeight: "700" }} >maximum amount of coverage provided for each shipment of goods.</span> It's like a cap on how much the insurance will pay out for any one trip of your goods from start to finish. This limit ensures you know the most you can get if something happens during transport.
        </>
        )
        },
    {
      question: "Q5.What should I do if my shipment is delayed?",
      answer: (
        <>
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Check Updates: </span>Contact the carrier to get details about the delay and when your shipment will arrive.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Inform Others: </span>Let your customers or recipients know about the delay and the new expected delivery time.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Keep Records: </span>Save any messages or emails about the delay for your records.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Minimize Impact:</span> Adjust your plans to minimize any problems caused by the delay.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Review Insurance: </span>If there are losses, check if your insurance covers delays and how to make a claim.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Stay in Touch:</span> Keep checking with the carrier for updates until the shipment arrives.
        </>
      )
      
    
    },
    {
      question: "Q6.Does a single transit policy cover the return shipment if goods are rejected?",
      answer: (
        <>
           A single transit policy usually <span style={{ color: "#F37435", fontWeight: "700" }} >doesn't cover the return shipment of goods if they're rejected. </span>This policy focuses on insuring goods during their initial trip from where they start to where they're supposed to end up. If goods are rejected and need to be sent back, that usually requires different insurance arrangements.
        </>
      )
      
    },
    {
      question: "Q7.What should I do if the goods arrive damaged?",
      answer: (
      
       <>
       If your goods arrive damaged, here’s what you should do:
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Take photos and notes of the damage right away.</span>
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Contact the shipping company to report the damage.</span> Keep all packaging as it was received. Check your insurance policy for coverage details.
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• File a claim and get the process started.</span>Stay in touch for updates on your claim.
      </>

      )
      
    },
    {
      question: "Q8.Can I adjust my shop owner insurance policy if my business expands or changes?",
      answer: (
        <>
          Yes, you can change your shop owner insurance as your business grows or changes. Just contact your insurance provider to update your policy based on new activities, locations, or inventory. This keeps your coverage current and tailored to your business needs.
        </>
      )
        
    },
    {
      question: "Q9.What is the difference between replacement cost and actual cash value coverage in shop owner insurance?",
      answer: 
      (
        <>
        Replacement Cost Coverage:
        What it does: Pays to replace damaged or stolen items with new ones of similar quality, without accounting for depreciation.
        Example: If your computer is stolen, this coverage would pay for a new computer of the same kind.
        Actual Cash Value (ACV) Coverage:
        What it does: Pays based on the current value of an item, considering depreciation.
        Example: If your stolen computer is 5 years old, ACV coverage would pay you what the computer is worth now, which is less than its original price.
        </>
      )
    },
    {
        question: "Q10.How does the policy handle partial damage or loss?",
        answer: 
        (
          <>
           If only part of your insured property is damaged or lost, the policy covers the cost to repair or replace that specific portion. The reimbursement is based on the extent of the damage compared to the total insured value of the property. Make sure to report any partial damage immediately and provide documentation to ensure your claim is processed smoothly.
          </>
        )
      },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default SingleTransitPolicyFAQ;